export enum Currency {
  CHF = 'CHF',
  EUR = 'EUR',
  USD = 'USD'
}
